module.exports = __webpack_public_path__ + "img/hongkong.f519b9cd.svg";